module.exports = __webpack_public_path__ + "img/66.f279f425.jpg";